import { BaseHttpAdapter } from '~/services/adapters/base-http.adapter';
import { INewServiceTemplate, IServiceTemplate } from '~/types/model.types';

export class ServiceTemplatesAdapter extends BaseHttpAdapter {
    fetchServiceTemplates(companyId: string) {
        return this.apiService.apiRequest<IServiceTemplate[]>({
            method: 'get',
            url: `/api/v2/company/${companyId}/service_templates`
        });
    }

    fetchOnboardingServiceTemplates(companyId: string) {
        return this.apiService.apiRequest<IServiceTemplate[]>({
            method: 'get',
            url: `/api/v2/company/${companyId}/ai_service_templates`
        });
    }

    fetchServiceTemplate(id: string, companyId: string) {
        return this.apiService.apiRequest<IServiceTemplate>({
            method: 'get',
            url: `/api/v2/company/${companyId}/service_template/${id}`
        });
    }

    createServiceTemplate(companyId: string, template: INewServiceTemplate) {
        return this.apiService.apiRequest<IServiceTemplate>({
            method: 'post',
            url: `/api/v2/company/${companyId}/service_template/`,
            data: template
        });
    }

    updateServiceTemplate(companyId: string, template: IServiceTemplate) {
        return this.apiService.apiRequest<IServiceTemplate>({
            method: 'put',
            url: `/api/v2/company/${companyId}/service_template/${template._id}`,
            data: template
        });
    }

    createInvoiceFromServiceTemplates(
        service_template_id: string,
        workspaceId: string | null,
        projectName: string | null
    ) {
        return this.apiService.apiRequest<{ flow_id: string }>({
            method: 'post',
            url: '/api/v2/flow/invoice_from_service_template',
            params: {
                workspace_id: workspaceId,
                project_name: projectName,
                service_template_id: service_template_id
            }
        });
    }

    deleteServiceTemplate(item: IServiceTemplate) {
        return this.apiService.apiRequest<void>({
            method: 'delete',
            url: `/api/v2/company/${item.company_id}/service_template/${item._id}`
        });
    }
    duplicateServiceTemplate(item: IServiceTemplate) {
        return this.apiService.apiRequest<IServiceTemplate>({
            method: 'post',
            url: `/api/v2/company/${item.company_id}/service_template/${item._id}`
        });
    }
}
